module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f61e.08b9e240.svg";